import { faCalendarAlt, faMapMarkerAlt } from '@fortawesome/pro-regular-svg-icons';

import { IconText } from '@/components/atoms';

interface EventDetailsProps {
	date: string;
	location: string;
	teamsText: string;
}

export function EventDetails({ date, location, teamsText }: EventDetailsProps) {
	return (
		<div className="flex flex-wrap gap-2 pt-4 text-base font-medium leading-6 sm:mr-4 md:mr-0 md:space-x-4 md:pt-4 lg:pt-8 xl:pt-8">
			<IconText icon={faCalendarAlt} text={date} className="pr-11 xl:pr-4" />
			<IconText icon={faMapMarkerAlt} text={location} className="md:pr-14 xl:pr-4" />
			<span className="flex items-center md:mr-4">{teamsText}</span>
		</div>
	);
}
